import React from 'react'
import { motion } from "framer-motion"
import {SiGooglemaps} from 'react-icons/si'
import {FiPhoneCall} from 'react-icons/fi'

const Info = ({isEng, showInfo, allergens, handleShowAllergensClick,showAllergens,  info }) => {
    
    const information =  info[0]
  
    let phone = information?.telephone
    
    let googleAddress = 'https://maps.app.goo.gl/rpEfq24zsPuoazZ87'
   
    return (
        
        <motion.div
            initial={false}
            animate={{height: showInfo ? 250 : 0}}            
            >
                <>
            {information && 
            <div>
            <div className={showInfo ? `flex flex-row   bg-backgroundOne items-center text-2xl text-mainTwo` : 'invisible '}>
            <div className='flex flex-col text-center w-9/12 ml-2'>
                <h1>{!isEng ? "Работно време:" : "Working hours:"}</h1>
                {information?.workingHours}                
                <p>{!isEng ? "Почивен ден:" : "Rest day:"}</p>
                {!isEng ? information?.restDay : information?.restDay_eng}
            </div>
            <div className='flex flex-col text-center items-center  w-5/12 mr-2'>
                
                <a className='flex flex-col' href={`tel:+${phone}`}>
                <div className='flex flex-row justify-center'>
                <h1>{!isEng ? "Тел. :" : "Phone :"}</h1> <motion.div
                    
                    animate={{scale:1.3}}
                    transition={{
                        repeat:Infinity,
                        repeatType:'reverse',
                        duration:1
                    }}
                ><FiPhoneCall className='ml-2 mt-2 mr-2 text-mainOne' /></motion.div>
                </div>
                <h1 className='mr-2'>+{information?.telephone} </h1>
                
                </a>              
                
                <a href={googleAddress}> 
                <div className='w-2/3 flex flex-row justify-center m-auto mt-2'>
                
                    <h1>{!isEng ? "Адрес:" : "Address:"}</h1>
                    <motion.div 
                    animate={{scale:1.3}}
                    
                    transition={{
                        repeat:Infinity,
                        repeatType:'reverse',
                        duration:1
                    }}>
                    <SiGooglemaps className='ml-2 text-mainOne' size={30}></SiGooglemaps>
                    </motion.div>
                    </div>
                   
                <h1 className='mr-2'>{!isEng ? information.address : information.address_eng}</h1>
                </a>
                
              
            </div>
            
                </div>
                {showInfo && <div className='mt-2 mb-2 mr-5 ml-5 cursor-pointer text-contours border-2 border-contours rounded-md'
                        onClick={() => {handleShowAllergensClick()
                            
                        }}> 
                    <p className='p-1 text-center'>Алергени </p>
                </div>}
                </div>}
                </>
        </motion.div>
    )
}

export default Info